<template>
  <div id="register-step0" class="register-step">
    <div id="main-part">
      <div class="register-header">
        <!-- <router-link to="home"> <span class="icon"> <i class="mdi mdi-arrow-left"></i> </span> </router-link> -->
        <div>          
          <div v-if="isApp === true">
            <a @click="closeRegisterNoConfirm">
              <span class="icon"> <i class="mdi mdi-arrow-left"></i> </span>
            </a>
          </div>
        </div>
        <h2>Nuevo Usuario</h2>
        <div></div>
      </div>
      <div class="register-content">
        <p
          v-html="
            getText(
              'register.step0.text1',
              'Plataforma dirigida a profesionales médicos. Utiliza el sistema de validación profesional de Navandu'
            )
          "
          class="primary-text"
        ></p>
        
        <LicenciaPremiumInput
          ref="premiumform"
          :validateOnBlur="true"
          :validateWithAuth="false"
          @validationStarted="validationStartedHandler"
          @validationFinished="validationFinishedHandler"
          :previousPremiumCode="this.$route.query.code"
        ></LicenciaPremiumInput>

        <div v-if="showloader" id="loader-container" style="text-align:center; margin-top: 10%">
            <Loader> </Loader>
        </div>

        <div
          class="notification is-danger"
          style="margin-top: 5px;margin-bottom:0px;"
          v-if="showErrorPremium && !isValidCode"
        >
          {{ errorPremiumMsg }}
        </div>
      </div>
      <div class="register-button-container">
        <a
          class="button is-fullwidth is-medium is-primary"
          @click="nextStepPremium"
          v-if="!showErrorPremium || isValidCode"
          :disabled="getClassbtn"
        >
          <span> Continuar Registro </span>
          <span class="icon is-small">
            <i class="mdi mdi-arrow-right"></i>
          </span>
        </a>

        <p
          class="is-size-7 has-text-centered mt-4"
          v-html="
            getText(
              'register.step0.nocodetip',
              'Si no tienes código premium también puedes usar la aplicación'
            )
          "
        ></p>
        <a
          class="button is-outlined is-primary mt-4 is-fullwidth"
          style=""
          @click="nextStep"
          v-if="!isValidCode && !mandatoryPremiumCode"
        >
          Continuar registro sin código premium
        </a>
      </div>

      <div id="belowbutton" class="mt-4">
        <p
          class="interface-small-text has-text-grey-light has-text-centered"
          v-if="this.isApp === false"
        >
          ¿Ya tienes usuario?
          <router-link to="login"> Entra a tu cuenta </router-link>
        </p>
      </div>
    </div>
    <!-- .main-part-->
  </div>
</template>
<script>
import { RegisterStepMixin } from '../mixins/RegisterStepMixin'
import { ToolsMixin } from '../mixins/ToolsMixin'
import LicenciaPremiumInput from './LicenciaPremiumInput.vue'
import Loader from '../UI/Loader.vue'

export default {
  name: 'RegisterStep0',
  mixins: [RegisterStepMixin, ToolsMixin],
  components: {
    LicenciaPremiumInput, Loader

  },
  data: () => ({
    code: '',
    errorPremiumMsg: '',
    showErrorPremium: false,
    activeLoading: false,
    showloader:false
  }),
  methods: {
    nextStepPremium() {
      console.log('nextStepPremium<<')

      if (this.activeLoading === true) {
        setTimeout(this.nextStepPremium, 500)
        console.log('--------------RETUUUUURN -------------')
        return
      }

      if (this.$store.state.register.validPremiumCode == true) this.nextStep()
      else {
        this.showErrorPremium = true
        this.errorPremiumMsg = this.getText(
          'register.step0.wrongcodemsg',
          'Introduce código válido, o continúa sin código'
        )
      }
    },
    validationStartedHandler() {
      this.activeLoading = true
    },
    validationFinishedHandler() {
      this.showErrorPremium = true
      this.activeLoading = false
      if (this.$store.state.register.validPremiumCode == false) {
        this.errorPremiumMsg = 'introduce código válido, o continúa sin código'
      } else {
        if (this.$route.query.code) {
          this.showloader = true
          setTimeout(() => this.nextStep(), 1500);
          // this.nextStep()
          // this.showloader = false
        }
      }
    },
    nextStep() {
      if (this.$store.state.register.validPremiumCode == false) {
        this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 1', 'premiumCodeError')
      } else {
        this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 1', 'Next')
      }

      this.$store.commit('register/nextStep')
      this.showloader = false
    },
    /* validate(){
      if(this.code.length === 0) return
      this.activeLoading=true
      this.$store.commit('register/cleanCredentials') //unauth petition
      this.$store.dispatch('register/validatePremiumCode',this.code)
        .finally(() => {
          this.activeLoading=false
          this.showErrorPremium=true
        })
    }, */
    prevStep() {
      this.$store.commit('register/prevStep')
    },
    handleKey(event) {
      if (event.keyCode === 13) {
        //document.getElementById("register-step0").focus();
        this.$refs.codeinput.$el.firstElementChild.blur()
        event.preventDefault()
        //  this.validate()
      }
    }
  },
  computed: {
    isValidCode() {
      return this.$store.state.register.validPremiumCode
    },
    getClassCard() {
      if (this.showErrorPremium == false) return ''
      else if (
        this.showErrorPremium == true &&
        this.$store.state.register.validPremiumCode == false
      )
        return 'is-danger'
      else if (
        this.showErrorPremium == true &&
        this.$store.state.register.validPremiumCode == true
      )
        return 'is-primary'
      else return ''
    },
    getClassbtn() {
      if (this.$store.state.register.validPremiumCode === true) return false
      else return true
    },
    isReadOnlyInput() {
      return this.$store.state.register.validPremiumCode
    },
    mandatoryPremiumCode() {
      return this._.get(
        this.$store.state.decoupled.configFile,
        'config.register.mandatory_premiumcode',
        false
      )
    }
  }
}
</script>
<style lang="less">
//@import (reference) '../../assets/styles/main.less';
#register-step0 {
  margin-top: 10px;

  #registerpremiumcodecard {
    margin-top: 2em;
    background: linear-gradient(114.9deg, #247ba0 2.27%, #2fa0d0 108.76%);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-radius: 8px;
    padding: 15px 15px;
    color: #fff;
    &.is-success {
      background: linear-gradient(114.9deg, #70c1b3 2.27%, #8de4d5 108.76%);
    }
    &.is-danger {
      background: linear-gradient(115.5deg, #ed6a5a 2.28%, #e29c94 116.9%);
    }
    div.premiumcodeform {
      margin-top: 10px;
      margin-bottom: 10px;
      text-align: center;
    }
    div.premiumcodeform > input.input {
      background-color: transparent !important;
      border: none;
      border-bottom: 1px white dashed;
      color: white;
      text-align: center;
      text-transform: uppercase;
      max-width: 12em;
    }
    &.is-success div.premiumcodeform > input.input {
      border-bottom: none;
    }
  }

  .register-button-container {
    margin-top: 1rem;
  }
}
</style>
